<template>
  <!-- <div class="modal-uniform-auth"> -->
  <div class="page--login new-form">
    <!-- modal here -->
    <div
      v-if="modalState > 0"
      class="login-modal active"
      :class="{
        otf: modalState,
        'login-modal--register': modalState === 2,
        'login-modal--forgot': modalState === 3,
        'login-modal--verification': modalState === 4,
        'login-modal--change-number': modalState === 5,
      }"
    >
      <div class="login-modal__header">
        <div v-show="modalState == 1">
          <a href="" class="login-modal__back hide-desktop" @click.prevent="changeNavbarState(0)">
            <img src="/assets/img/arrow_left.svg" />Login
          </a>
          <a href="" class="login-modal__close hide-mobile" @click.prevent="changeNavbarState(0)">
            <img src="/assets/img/close.svg" />
          </a>
        </div>
        <div v-show="modalState === 2">
          <a href="" class="login-modal__back hide-desktop" @click.prevent="changeNavbarState(0)">
            <img src="/assets/img/arrow_left.svg" />Create Your Account
          </a>
          <a href="" class="login-modal__close hide-mobile" @click.prevent="changeNavbarState(0)">
            <img src="/assets/img/close.svg" />
          </a>
        </div>
        <div v-show="modalState === 3 || $store.state.modal.isModalShow.forgetPassword">
          <a href="" class="login-modal__back hide-desktop" @click.prevent="changeNavbarState(0)">
            <img src="/assets/img/arrow_left.svg" />Forgot Password
          </a>
          <span class="login-modal__title hide-mobile"> Forgot Password </span>
          <a href="" class="login-modal__close hide-mobile" @click.prevent="changeNavbarState(0)">
            <img src="/assets/img/close.svg" />
          </a>
        </div>

        <div v-show="modalState === 4">
          <a href="" class="login-modal__back hide-desktop" @click.prevent="changeNavbarState(0)">
            <img src="/assets/img/arrow_left.svg" />
            <span v-if="isOtpSent">Verification Via {{ otpMethod.charAt(0).toUpperCase() + otpMethod.slice(1) }}</span>
            <span v-else>Verify Your Account</span>
          </a>
          <p class="login-modal__title hide-mobile">
            <span v-if="isOtpSent">Verification Via {{ otpMethod.charAt(0).toUpperCase() + otpMethod.slice(1) }}</span>
            <span v-else>Verify Your Account</span>
          </p>
          <a v-if="!isOtpSent" href="" class="login-modal__close hide-mobile" @click.prevent="changeNavbarState(0)">
            <img src="/assets/img/close.svg" />
          </a>
        </div>

        <div v-show="modalState === 5">
          <a
            href=""
            class="login-modal__back hide-desktop"
            @click.prevent="
              () => {
                $store.commit('toggleModalGlobalState', {
                  modalName: 'offlineRegistration',
                });
                changeNavbarState(0);
              }
            "
          >
            <img src="/assets/img/arrow_left.svg" />Enter Your Phone Number
          </a>
          <span class="login-modal__title hide-mobile"> Enter Your Phone Number </span>
          <a
            href=""
            class="login-modal__close hide-mobile"
            @click.prevent="
              () => {
                $store.commit('toggleModalGlobalState', {
                  modalName: 'offlineRegistration',
                });
                changeNavbarState(0);
              }
            "
          >
            <img src="/assets/img/close.svg" />
          </a>
        </div>
      </div>
      <div class="login-modal__body">
        <!-- sign in -->
        <div v-show="modalState == 1" class="sign-in-wrap active">
          <div class="head-mobile">
            <router-link title="SOCO" to="/login" exact>
              <img src="/assets/img/logo-soco.svg" alt="SOCO" class="head-mobile__logo" />
            </router-link>
            <!-- <p class="login-modal__copywriting">Masuk dengan akun SOCO</p> -->
          </div>
          <LoginThirdParty />
          <div v-if="showMessageLimit" class="information-slow-down">
            <img src="/assets/img/icons/exclamation-mark.svg" class="svg-icon" />
            <div class="desc">
              <template v-if="showMessageLimitCount">
                <template v-if="showMessageLimitCount === 4">
                  Please <a href="" @click.prevent="changeNavbarState(3)">Reset Your Password</a> before the account is
                  blocked.
                </template>
                <template v-else-if="showMessageLimitCount === 5">
                  Your account is blocked because 5 times you failed to login. Please
                  <a href="" @click.prevent="changeNavbarState(3)">Reset Your Password</a> to access the account.
                </template>
              </template>
              <template v-else-if="showMessageUserDeleted">
                Akun kamu tidak dapat diakses. Jika ini sebuah kesalahan, silahkan hubungi
                <a href="mailto:cs@sociolla.com">cs@sociolla.com</a>
              </template>
            </div>
          </div>
          <form
            id="form-login"
            method="post"
            name="form-login"
            data-vv-scope="form-login"
            @submit.prevent="validateBeforeSubmit('form-login')"
          >
            <div class="field" :class="{ 'has-error': errors.has('form-login.username') }">
              <label class="text-label" for="username">Email / Username</label>
              <div class="fieldarea">
                <input
                  id="username"
                  ref="loginFirst"
                  v-model="loginData.username"
                  v-validate="'required'"
                  type="text"
                  class="text"
                  placeholder=""
                  name="username"
                  @focus="onFocusInInputLogin"
                  @blur="onBlurInInputLogin"
                />
                <p v-show="errors.has('form-login.username')" class="alert">
                  {{ errors.first('form-login.username') }}
                </p>
              </div>
            </div>
            <div class="field" :class="{ 'has-error': errors.has('form-login.password') }">
              <label class="text-label" for="password">Password</label>
              <div class="fieldarea password xxx">
                <input
                  v-model="loginData.password"
                  v-validate="'required'"
                  class="text"
                  placeholder=""
                  name="password"
                  :type="revealPassword"
                  @focus="onFocusInInputLogin"
                  @blur="onBlurInInputLogin"
                />
                <span class="reveal" :class="{ show: revealPassword == 'text' }" @click="togglePassword"></span>
                <p v-show="errors.has('form-login.password')" class="alert">
                  {{ errors.first('form-login.password') }}
                </p>
              </div>
            </div>
            <div class="field">
              <input id="tetap" v-model="loginData.remember" type="checkbox" class="checkbox" name="tetap" />
              <label class="text-label text-label--nomargin" for="tetap">Keep Login</label>
              <a
                href=""
                title="Lupa kata sandi"
                class="float-right text-forgot-password"
                @click.prevent="changeNavbarState(3)"
                >Forgot password</a
              >
            </div>
            <div class="formaction" :class="!screen.isDesktop ? 'bottom__65' : ''">
              <input v-if="showLoader == false" type="submit" value="Login" class="submit button btn-danger" />
              <loaderspin v-else />
            </div>
            <div class="store-registered">
              <p class="store-registered__text">If you already registered in Sociolla Store</p>
              <a href="" class="store-registered__activate" @click.prevent="changeNavbarState(5)">
                Activate your account here
              </a>
            </div>
          </form>
        </div>
        <!-- sign up -->
        <div v-show="modalState == 2" class="sign-up-wrap active">
          <div class="head-mobile">
            <router-link title="SOCO" to="/login" exact>
              <img src="/assets/img/logo-soco.svg" alt="SOCO" class="head-mobile__logo" />
            </router-link>
          </div>
          <LoginThirdParty />
          <p class="login-modal__copywriting">Come on, join our community</p>
          <form
            id="form-register"
            method="post"
            name="form-register"
            data-vv-scope="form-register"
            @submit.prevent="validateBeforeSubmit('form-register')"
          >
            <div class="form-inline-wrap">
              <div class="field" :class="{ 'has-error': errors.has('form-register.firstname') }">
                <label class="text-label" for="firstname">First Name <span class="required">*</span></label>
                <div class="fieldarea">
                  <input
                    id="firstname"
                    ref="registerFirst"
                    v-model="registerData.firstname"
                    v-validate="'required|alpha_dash|min:1|max:32'"
                    type="text"
                    class="text"
                    placeholder=""
                    name="firstname"
                    autocomplete="off"
                    style="text-transform: capitalize"
                    @blur="generateUserName"
                  />
                  <p v-show="errors.has('form-register.firstname')" class="alert">
                    {{ errors.first('form-register.firstname') }}
                  </p>
                </div>
              </div>
              <div class="field" :class="{ 'has-error': errors.has('form-register.lastname') }">
                <label class="text-label" for="lastname">Last Name <span class="required">*</span></label>
                <div class="fieldarea">
                  <input
                    id="lastname"
                    v-model="registerData.lastname"
                    v-validate="'required|alpha_dash|min:1|max:32'"
                    type="text"
                    class="text"
                    style="text-transform: capitalize"
                    placeholder=""
                    name="lastname"
                    autocomplete="off"
                    @blur="generateUserName"
                  />
                  <p v-show="errors.has('form-register.lastname')" class="alert">
                    {{ errors.first('form-register.lastname') }}
                  </p>
                </div>
              </div>
            </div>

            <div class="field" :class="{ 'has-error': errors.has('form-register.regusername') }">
              <label class="text-label" for="regusername">Username<span class="required">*</span></label>
              <div class="fieldarea">
                <div class="fieldarea fieldarea--addon" :class="{ 'fieldarea--addon_focus': isInputUsernameFocus }">
                  <span class="fieldarea__addon">
                    <span class="">soco.id/</span>
                  </span>
                  <input
                    id="regusername"
                    v-model="registerData.username"
                    v-validate="'required|alpha_dash|min:4|max:16'"
                    type="text"
                    class="text"
                    placeholder=""
                    name="regusername"
                    autocomplete="off"
                    @focus="onFocusInInputUsername"
                    @blur="verifyUsername"
                  />
                </div>
                <div v-if="isUsernameAvailable && !errors.has('form-register.regusername')">
                  <p class="alert alert_success">Username available</p>
                </div>
                <div v-if="$SO.size(listSuggestionUsername) && !errors.has('form-register.regusername')">
                  <p class="alert alert--suggestion">Username already used. Recommendation username available :</p>
                  <ul class="list-username-suggestion">
                    <li
                      v-for="(usernameSuggestion, key) in listSuggestionUsername"
                      :key="key"
                      @click.prevent="pickUsenameSuggestion(key)"
                    >
                      {{ usernameSuggestion }}
                    </li>
                  </ul>
                </div>
                <p v-show="errors.has('form-register.regusername')" class="alert">
                  {{ errors.first('form-register.regusername') }}
                </p>
              </div>
            </div>

            <div
              class="field"
              :class="{
                'has-error': errors.has('form-register.email') || !isEmailAvailable,
              }"
            >
              <label class="text-label" for="email">Email <span class="required">*</span></label>
              <div class="fieldarea" style="position: relative">
                <input
                  id="email"
                  key="email"
                  v-model="registerData.email"
                  v-validate
                  type="text"
                  class="text"
                  placeholder="Enter your email"
                  name="email"
                  autocomplete="off"
                  :style="!isEmailAvailable && registerData.email ? 'border: 1px solid #DA2A52;' : ''"
                  data-vv-rules="required|email"
                  @keyup="showEmailDomainSuggestion"
                  @blur="
                    hideShowEmailDomainSuggestion();
                    verifyEmail(registerData.email);
                  "
                />
                <p v-show="errors.has('form-register.email')" class="alert">
                  {{ errors.first('form-register.email') }}
                </p>
                <!-- <p v-if="isErrorAlreadyExist" class="alert">Username or email already exists.</p> -->
                <div v-show="isEmailDomainSuggestionShow" class="email-domain-suggestion">
                  <ul>
                    <li
                      v-for="(domain, idx) in emailDomainSuggestion"
                      :key="idx"
                      @mousedown.prevent="populateEmailSuggestion(idx)"
                    >
                      {{ formattedEmail }}<span class="domain">{{ domain }}</span>
                    </li>
                  </ul>
                </div>
                <template v-if="!emailCheck.loading">
                  <div
                    v-if="
                      !isEmailAvailable && registerData.email && !errors.has('form-register.email') && emailCheck.error
                    "
                    class="error-email-available"
                  >
                    <p class="alert" style="font-size: inherit">
                      {{ emailCheck.error }}
                    </p>
                  </div>
                </template>
                <loaderspin v-else id="input-check-loading"></loaderspin>
              </div>
            </div>

            <div
              class="field"
              :class="{
                'has-error': errors.has('form-register.minhp') || !isPhoneAvailable,
              }"
            >
              <div class="hp-label-wrapper">
                <label class="text-label" for="hp">Phone Number <span class="required">*</span></label>
                <label class="text-label" for="hp">e.g: 85612345678</label>
              </div>
              <div
                class="fieldarea fieldarea--addon fieldarea--input-with-text"
                :class="{ 'fieldarea--addon_focus': isInputPhoneFocus }"
              >
                <div>
                  <span class="fieldarea__addon" @click.prevent="showOverseas()">
                    <template v-if="userCountry && !Object.keys(userCountry).length">
                      <span class=""
                        ><img src="/assets/img/indonesia-flag.svg" class="field__icon-flag" />+62<img
                          src="/assets/img/triangle-down.svg"
                          class="field__icon-triangle"
                      /></span>
                    </template>
                    <template v-else>
                      <span class=""
                        ><img :src="userCountry.flag" class="field__icon-flag" />{{ `${userCountry.phone_code}`
                        }}<img src="/assets/img/triangle-down.svg" class="field__icon-triangle"
                      /></span>
                    </template>
                  </span>
                  <overseas-phone v-if="isShowModalOverseas" />
                </div>
                <input
                  id="minhp"
                  v-model="registerData.phone_no"
                  v-validate="'required|numeric|min:7|max:14'"
                  type="text"
                  class="text addon"
                  placeholder="Enter phone number"
                  name="minhp"
                  autocomplete="off"
                  @focus="onFocusInInputPhone"
                  @blur="onBlurInInputPhone($event.target.value)"
                />
                <template v-if="!phoneCheck.loading">
                  <p v-show="errors.has('form-register.minhp')" class="alert">
                    {{ errors.first('form-register.minhp') }}
                  </p>
                  <p
                    v-show="!isPhoneAvailable && !errors.has('form-register.minhp')"
                    class="alert"
                    :class="{ registeredOffline: isRegisteredOffline }"
                  >
                    {{ phoneCheck.error }}
                  </p>
                </template>
                <loaderspin v-else id="input-check-loading"></loaderspin>
                <template v-if="isRegisteredOffline">
                  <a href="" class="alert activation" @click.prevent="changeNavbarState(5)">
                    Activate your account here
                  </a>
                </template>
              </div>
            </div>

            <div class="field" :class="{ 'has-error': errors.has('form-register.regpassword') }">
              <label class="text-label" for="regpassword">Password <span class="required">*</span></label>
              <div class="fieldarea password">
                <input
                  id="regpassword"
                  ref="regpassword"
                  v-model="registerData.password"
                  v-validate="'required|min:6|max:60'"
                  class="text"
                  placeholder="Password min 6 characters"
                  name="regpassword"
                  autocomplete="off"
                  :type="revealPassword"
                />
                <span class="reveal" :class="{ show: revealPassword == 'text' }" @click="togglePassword"></span>
                <p v-show="errors.has('form-register.regpassword')" class="alert">
                  {{ errors.first('form-register.regpassword') }}
                </p>
              </div>
            </div>

            <div>
              <label class="text-label" for="jenkel">Gender</label>
              <div class="form-inline-wrap">
                <div class="field">
                  <label class="radio-donut text-label">
                    <input v-model="registerData.salute_id" type="radio" name="jenkel" value="1" checked />
                    Female
                    <span></span>
                  </label>
                </div>

                <div class="field">
                  <label class="radio-donut text-label">
                    <input v-model="registerData.salute_id" type="radio" name="jenkel" value="2" />
                    Male
                    <span></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="field privacyPolicy-wrapper" :class="{ 'has-error': errors.has('form-register.regpassword') }">
              <input
                id="privacyPolicy"
                v-model="registerData.privacyPolicy"
                type="checkbox"
                class="checkbox"
                name="privacyPolicy"
              />
              <label class="text-label text-label--nomargin text-layanan" for="privacyPolicy">
                By registering you have agreed to the
                <a href="" class="text-danger" @click.prevent="showPrivacyPolicyModal()">Privacy Policy</a> and
                <a href="" class="text-danger" @click.prevent="showTermsofserviceModal()">Terms of Service</a>
              </label>
            </div>
            <vue-recaptcha
              ref="recaptcha"
              class="field recaptcha"
              @verify="onRecaptchaVerify"
              @expired="onRecaptchaExpired"
              @error="onRecaptchaError"
            ></vue-recaptcha>

            <div class="formaction">
              <input
                v-if="showLoader == false"
                type="submit"
                value="Create account"
                class="submit button btn-danger"
                :class="{ 'button_style-disabled': !isRegisterButtonAvailable }"
                :disabled="!isRegisterButtonAvailable"
              />
              <loaderspin v-else />
            </div>
          </form>
        </div>
        <!-- forget pass -->
        <div v-show="showForgotPasswordModal" class="forgot-pass-wrap active">
          <div class="head-mobile">
            <p v-if="isResetPasswordTokenExpired" class="box-alert">
              <span style="position: relative; z-index: 100"
                >Link reset password sudah tidak dapat digunakan, masukkan alamat email kamu untuk meminta link reset
                password yang baru.</span
              >
              <span class="box-alert__icon"></span>
            </p>

            <router-link title="SOCO" to="/login" exact>
              <img src="/assets/img/logo-soco.svg" alt="SOCO" class="head-mobile__logo" />
            </router-link>
            <h6 class="modal-subheading">
              Use your phone number or email address to <br />
              reset your password
            </h6>
          </div>
          <form method="post" data-vv-scope="form-forgot" @submit.prevent="submitForgetPassword(forgot)">
            <div class="icon-label">
              <div
                :class="[{ active: forgetPassword.mode === 'phone' }, 'icon-label-phone']"
                @click.prevent="setforgetPasswordBy('phone')"
              >
                <template>
                  <img :src="`/assets/img/hp-icon-${forgetPassword.mode === 'phone' ? 'bw' : 'gray'}.svg`" />
                </template>
                <span>Phone number</span>
              </div>
              <div
                :class="[{ active: forgetPassword.mode === 'email' }, 'icon-label-email']"
                @click.prevent="setforgetPasswordBy('email')"
              >
                <template>
                  <img :src="`/assets/img/mail-icon-${forgetPassword.mode === 'email' ? 'bw' : 'gray'}.svg`" />
                </template>
                <span>Email</span>
              </div>
            </div>
            <div class="field">
              <div class="fieldarea">
                <template v-if="forgetPassword.mode === 'phone'">
                  <div
                    class="fieldarea fieldarea--addon fieldarea--input-with-text"
                    :class="{ 'fieldarea--addon_focus': isInputPhoneFocus }"
                  >
                    <div>
                      <span class="fieldarea__addon" @click.prevent="showOverseas()">
                        <template v-if="userCountry && !Object.keys(userCountry).length">
                          <span class=""
                            ><img src="/assets/img/indonesia-flag.svg" class="field__icon-flag" />+62<img
                              src="/assets/img/triangle-down.svg"
                              class="field__icon-triangle"
                          /></span>
                        </template>
                        <template v-else>
                          <span class=""
                            ><img :src="userCountry.flag" class="field__icon-flag" />{{ `${userCountry.phone_code}`
                            }}<img src="/assets/img/triangle-down.svg" class="field__icon-triangle"
                          /></span>
                        </template>
                      </span>
                      <overseas-phone v-if="isShowModalOverseas" />
                    </div>
                    <input
                      id="minhp"
                      v-model="forgot.phone"
                      v-validate="'required|numeric|min:4|max:14'"
                      v-focus
                      type="text"
                      class="text addon"
                      name="minhp"
                      autocomplete="off"
                    />
                  </div>
                  <div class="fieldarea--label">
                    <p v-show="errors.has('form-forgot.minhp')" class="alert">
                      {{ errors.first('form-forgot.minhp') }}
                    </p>
                    <span class="phone-example">e.g: <strong>85612345678</strong></span>
                  </div>
                </template>
                <template v-if="forgetPassword.mode === 'email'">
                  <div class="fieldarea" style="position: relative">
                    <input
                      v-model="forgot.email"
                      v-validate
                      v-focus
                      type="text"
                      class="text"
                      placeholder=""
                      name="email"
                      data-vv-rules="required|email"
                      @keyup="showForgotEmailDomainSuggestion"
                      @blur="hideShowForgotEmailDomainSuggestion"
                    />
                    <div v-show="isEmailDomainSuggestionShow" class="email-domain-suggestion">
                      <ul>
                        <li
                          v-for="(domain, idx) in emailDomainSuggestion"
                          :key="idx"
                          @mousedown.prevent="populateForgotEmailSuggestion(idx)"
                        >
                          {{ formattedForgotEmail }}<span class="domain">{{ domain }}</span>
                        </li>
                      </ul>
                    </div>
                    <p v-show="errors.has('form-forgot.email')" class="alert">
                      {{ errors.first('form-forgot.email') }}
                    </p>
                  </div>
                </template>
              </div>
            </div>

            <div
              class="formaction"
              :style="{
                marginTop: forgetPassword.mode === 'phone' ? '12px' : '16px',
              }"
            >
              <input
                v-if="showLoader == false"
                type="submit"
                class="submit button btn-danger"
                value="Send"
                :disabled="
                  forgetPassword.mode === 'email'
                    ? errors.has('form-forgot.email') || !forgot.email
                    : errors.has('form-forgot.minhp') || !forgot.phone
                "
              />
              <loaderspin v-else />
            </div>
          </form>
          <div v-show="screen.isDesktop" class="footer-forgot-password">
            <p class="login-modal__footer__text">
              Back to
              <!-- <router-link title="Login" to="/login" class="login-modal__footer__link" exact>Login</router-link>
                           atau
                          <router-link title="Daftar" to="/register" class="login-modal__footer__link" exact>Daftar</router-link> -->
              <a href="" class="login-modal__footer__link" @click.prevent="changeNavbarState(1)">Login</a>
              or
              <a href="" class="login-modal__footer__link" @click.prevent="changeNavbarState(2)">Register</a>
            </p>
          </div>
        </div>
        <!-- verification form -->
        <div v-show="modalState == 4" class="verification-wrap active">
          <template v-if="otpCheckLoading">
            <div class="loader-spin-wrapper">
              <loaderspin></loaderspin>
            </div>
          </template>
          <template v-else>
            <!-- <p v-show="screen.isDesktop" class="head">
              VERIFICATION
              <span v-show="isOtpSent" style="text-transform: uppercase">via {{ otpMethod }}</span>
            </p> -->
            <div v-if="!isOtpSent" :class="{ 'm-top-27': !isOtpSent && screen.isDesktop }">
              <p class="sub-head" v-html="verificationSubHead"></p>
              <div class="verification-methods">
                <p class="verification-methods-title">Choose a verification method:</p>
                <div v-if="smsEnabled || whatsappEnabled" class="verification-methods-selection method">
                  <div v-if="whatsappEnabled" class="method-whatsapp" @click="selectOtpMethod('whatsapp')">
                    <div class="wrapper">
                      <img class="icon" src="/assets/img/wa-icon.svg" />
                      <span>Via WhatsApp to number </span>
                      <span class="number"><strong v-html="formattedPhoneNumber"></strong></span>
                    </div>
                    <img class="chevron" src="/assets/img/chevron_right.svg" />
                  </div>
                  <div v-if="smsEnabled" class="method-sms" @click="selectOtpMethod('sms')">
                    <div class="wrapper">
                      <img class="icon" src="/assets/img/smartphone.svg" />
                      <span>Via SMS to number </span>
                      <span class="number"><strong v-html="formattedPhoneNumber"></strong></span>
                    </div>
                    <img class="chevron" src="/assets/img/chevron_right.svg" />
                  </div>
                </div>
                <div v-else class="verification-methods-selection--disabled">
                  <div class="img">
                    <img src="/assets/img/exclamation-mark.svg" alt="exclamation-mark" />
                  </div>
                  <span>
                    {{
                      otpScope === 'forget-password'
                        ? 'Saat ini proses verifikasi tidak dapat dilakukan melalui nomor handphone, silakan verifikasi dengan email'
                        : 'Saat ini proses verifikasi tidak dapat dilakukan, silakan melanjutkan aktifitas mu di SOCO dan coba verifikasi beberapa saat lagi'
                    }}
                  </span>
                </div>
              </div>
              <div
                v-if="
                  (!inChangeNumberState && !inForgotPasswordState && !isRegisteredOffline) ||
                  (!smsEnabled && !whatsappEnabled)
                "
                class="verification-not-received"
              >
                <!-- <div v-if="!inForgotPasswordState">Tidak menerima kode melalui SMS?</div> -->
                <a href="" class="email-link" @click.prevent="selectOtpMethod('email')">Verification via email</a>
              </div>
            </div>
            <div v-else :class="{ 'm-top-80': isOtpSent && screen.isDesktop }">
              <div class="head-mobile">
                <img v-if="otpMethod === 'whatsapp'" class="icon" src="/assets/img/whatsapp.svg" />
                <img v-if="otpMethod === 'sms'" class="icon" src="/assets/img/smartphone.svg" />
                <img v-if="otpMethod === 'email'" class="icon" src="/assets/img/email.svg" />
                <p
                  v-show="inForgotPasswordState && otpMethod === 'email'"
                  :style="{ marginTop: '24px' }"
                  v-html="verificationSubHead"
                ></p>
                <p
                  :style="{
                    marginTop: inForgotPasswordState ? '16px' : '20px',
                  }"
                >
                  We have sent a verification code via <br />
                  {{ otpMethod }}
                  to
                  <span
                    ><strong>{{ verificationAddress }}</strong></span
                  >
                </p>
              </div>
              <form class="verification-otp" method="post" @submit.prevent="submitOtpFromInstance">
                <p
                  class="otp-title"
                  :style="{
                    marginTop: otpMethod === 'email' ? '16px' : '24px',
                  }"
                >
                  Enter verification code
                </p>
                <template>
                  <div style="display: flex; flex-direction: row; justify-content: center">
                    <otp-input
                      ref="otpInput"
                      input-classes="otp-input"
                      separator=""
                      :num-inputs="6"
                      :should-auto-focus="true"
                      @on-change="otpChange"
                      @on-complete="handleOnComplete"
                    />
                  </div>
                </template>
                <p v-show="otpError" class="otp-error">{{ otpError }}</p>
                <div class="formaction">
                  <input
                    v-if="!$store.state.otp.loading"
                    type="submit"
                    value="Verifikasi"
                    class="submit button btn-danger"
                    :disabled="!enableVerification"
                  />
                  <loaderspin v-else />
                </div>
              </form>
              <div class="verification-send-again text-waiting">
                <p v-if="otpIntervalCount && isOtpSent !== 'email'">
                  Wait <strong>{{ otpIntervalCount }} seconds</strong> before resending
                </p>
                <div v-else-if="!maxReached">
                  <p style="margin-bottom: 0">Didn't receive the verification code?</p>
                  <p style="margin-top: 0">
                    <a class="text-danger" title="Kirim ulang" href="" @click.prevent="sendOtpAgain()">Resend</a>
                    <template v-if="otpScope !== 'change-number'">
                      or
                      <a
                        v-if="otpMethod !== 'email' && !isRegisteredOffline"
                        class="text-danger"
                        title="Ganti verifikasi dengan email"
                        href=""
                        @click.prevent="selectOtpMethod('email')"
                        >Change verification method</a
                      >
                      <a
                        v-else-if="
                          !userCountry ||
                          (userCountry && (userCountry.phone_code === '+62' || userCountry.phone_code === '+84'))
                        "
                        class="text-danger"
                        title="Ganti verifikasi dengan homor handphone"
                        href=""
                        @click.prevent="selectOtpMethod('sms')"
                        >Change verification method</a
                      >
                      <a
                        v-else-if="
                          userCountry && (userCountry.phone_code !== '+62' || userCountry.phone_code !== '+84')
                        "
                        class="text-danger"
                        title="Ganti verifikasi dengan homor handphone"
                        href=""
                        @click.prevent="selectOtpMethod('whatsapp')"
                        >Change verification method</a
                      >
                    </template>
                  </p>
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- phone offline verification -->
        <div v-show="modalState == 5 && screen.isDesktop" class="sign-up-wrap active">
          <div class="store-registered__information">
            <p class="store-registered__information__info">Enter your registered phone number at Sociolla Store</p>
          </div>
          <form
            id="form-offline"
            method="post"
            name="form-offline"
            data-vv-scope="form-offline"
            @submit.prevent="submitOfflineRegistration(offlineRegistration)"
          >
            <div class="field">
              <div class="hp-label-wrapper">
                <label class="text-label" for="hp">Use active phone number <span class="required">*</span></label>
              </div>
              <div class="fieldarea">
                <template>
                  <div
                    class="fieldarea fieldarea--addon fieldarea--input-with-text"
                    :class="{ 'fieldarea--addon_focus': isInputPhoneFocus }"
                  >
                    <div>
                      <span class="fieldarea__addon" @click.prevent="showOverseas()">
                        <template v-if="userCountry && !Object.keys(userCountry).length">
                          <span class=""
                            ><img src="/assets/img/indonesia-flag.svg" class="field__icon-flag" />+62<img
                              src="/assets/img/triangle-down.svg"
                              class="field__icon-triangle"
                          /></span>
                        </template>
                        <template v-else>
                          <span class=""
                            ><img :src="userCountry.flag" class="field__icon-flag" />{{ `${userCountry.phone_code}`
                            }}<img src="/assets/img/triangle-down.svg" class="field__icon-triangle"
                          /></span>
                        </template>
                      </span>
                      <overseas-phone v-if="isShowModalOverseas" />
                    </div>
                    <input
                      id="minhp"
                      v-model="offlineRegistration.phone"
                      v-validate="'required|numeric|min:4|max:14'"
                      type="text"
                      class="text addon"
                      name="minhp"
                      autocomplete="off"
                      @focus="onFocusInInputPhoneOffline"
                      @blur="onBlurInInputPhoneOffline($event.target.value)"
                    />
                  </div>
                  <template v-if="!phoneCheckOffline.loading">
                    <p v-show="errors.has('form-offline.minhp')" class="alert">
                      {{ errors.first('form-offline.minhp') }}
                    </p>
                    <p
                      v-show="!isPhoneAvailable && !errors.has('form-offline.minhp')"
                      class="alert"
                      :class="{ registeredOffline: isRegisteredOffline }"
                    >
                      {{ phoneCheckOffline.error }}
                    </p>
                  </template>
                </template>
              </div>
            </div>

            <div class="formaction">
              <input
                v-if="showLoader == false"
                type="submit"
                class="submit button btn_black btn_submit"
                value="Submit"
                :disabled="disabledSubmit"
              />
              <loaderspin v-else />
            </div>
          </form>
        </div>
      </div>
      <div v-show="modalState === 1" class="login-modal__footer">
        <p class="login-modal__footer__text">
          Not have account?
          <a href="" class="login-modal__footer__link" @click.prevent="changeNavbarState(2)">Register</a>
        </p>
      </div>

      <div v-show="modalState === 2" class="login-modal__footer">
        <p class="login-modal__footer__text">
          Already have an account?
          <a href="" class="login-modal__footer__link" @click.prevent="changeNavbarState(1)">Login</a>
        </p>
      </div>

      <div v-show="modalState === 4 && otpMethod !== 'email' && !inChangeNumberState" class="login-modal__footer">
        <p
          v-if="!isOtpSent && !inForgotPasswordState && !isRegisteredOffline"
          class="login-modal__footer__text login-modal__footer__text--verification"
        >
          <a href="" class="login-modal__footer__link" @click.prevent="skipVerification">SKIP</a>
        </p>
        <p v-if="isOtpSent" class="login-modal__footer__text login-modal__footer__text--verification-method">
          <span style="margin-bottom: 6px; display: inline-block">Incorrect phone number?</span>&nbsp;<a
            href=""
            class="login-modal__footer__link login-modal__footer__link--verification"
            @click.prevent="toggleChangeNumberModal"
            >Change number</a
          >
        </p>
      </div>

      <template v-if="isShowModalOfflineRegist && !screen.isDesktop">
        <GModal
          id="pills-dropdown-mobile"
          class="pills-dropdown-mobile"
          :class="{ 'height-full': isShowModalOverseas }"
        >
          <template slot="header">
            <div class="rectangle-top"></div>
            <div class="modal-heading">
              <h4 class="modal-heading--title">Enter Your Phone Number</h4>
              <a
                href=""
                type="button"
                class="close modal-heading--close"
                data-dismiss="modal"
                aria-label="Close"
                @click.prevent="
                  () => {
                    changeNavbarState(1);
                    $store.commit('toggleModalGlobalState', {
                      modalName: 'offlineRegistration',
                    });
                  }
                "
              >
                <img src="/assets/img/icons/close-modal.svg" height="14" width="14" />
              </a>
            </div>
          </template>
          <template slot="body">
            <div class="content-modal">
              <div class="sign-up-wrap active">
                <div class="store-registered__information">
                  <p class="store-registered__information__info">
                    Enter your registered phone number at Sociolla Store
                  </p>
                </div>
                <form
                  id="form-offline"
                  method="post"
                  name="form-offline"
                  data-vv-scope="form-offline"
                  @submit.prevent="submitOfflineRegistration(offlineRegistration)"
                >
                  <div class="field">
                    <div class="hp-label-wrapper">
                      <label class="text-label" for="hp">Use active phone number <span class="required">*</span></label>
                    </div>
                    <div class="fieldarea">
                      <template>
                        <div
                          class="fieldarea fieldarea--addon fieldarea--input-with-text"
                          :class="{ 'fieldarea--addon_focus': isInputPhoneFocus }"
                        >
                          <div>
                            <span class="fieldarea__addon" @click.prevent="showOverseas()">
                              <template v-if="userCountry && !Object.keys(userCountry).length">
                                <span class=""
                                  ><img src="/assets/img/indonesia-flag.svg" class="field__icon-flag" />+62<img
                                    src="/assets/img/triangle-down.svg"
                                    class="field__icon-triangle"
                                /></span>
                              </template>
                              <template v-else>
                                <span class=""
                                  ><img :src="userCountry.flag" class="field__icon-flag" />{{
                                    `${userCountry.phone_code}`
                                  }}<img src="/assets/img/triangle-down.svg" class="field__icon-triangle"
                                /></span>
                              </template>
                            </span>
                            <overseas-phone v-if="isShowModalOverseas" />
                          </div>
                          <input
                            id="minhp"
                            v-model="offlineRegistration.phone"
                            v-validate="'required|numeric|min:4|max:14'"
                            type="text"
                            class="text addon"
                            name="minhp"
                            autocomplete="off"
                            @focus="onFocusInInputPhoneOffline"
                            @blur="onBlurInInputPhoneOffline($event.target.value)"
                          />
                        </div>
                        <template v-if="!phoneCheckOffline.loading">
                          <p v-show="errors.has('form-offline.minhp')" class="alert">
                            {{ errors.first('form-offline.minhp') }}
                          </p>
                          <p
                            v-show="!isPhoneAvailable && !errors.has('form-offline.minhp')"
                            class="alert"
                            :class="{ registeredOffline: isRegisteredOffline }"
                          >
                            {{ phoneCheckOffline.error }}
                          </p>
                        </template>
                      </template>
                    </div>
                  </div>

                  <div class="formaction">
                    <input
                      v-if="showLoader == false"
                      type="submit"
                      class="btn btn_black btn_submit"
                      value="Submit"
                      :disabled="disabledSubmit"
                    />
                    <loaderspin v-else />
                  </div>
                </form>
              </div>
            </div>
          </template>
        </GModal>
      </template>
    </div>
    <div v-if="modalState > 0" class="login-modal__overlay hidden-xs active" :class="{ otf: modalState > 0 }"></div>

    <div v-if="showConfirmEmail" class="modal-confirm-email">
      <div class="modal-container">
        <div class="content">
          <p class="text-center copywriting">
            Anda telah menerima email yang berisi link untuk mengatur ulang password.
            <br />
            <strong>Cek email Anda.</strong>
          </p>
          <a
            href=""
            class="button-minimalis button_style-danger button-finish button-block"
            @click.prevent="showConfirmEmail = false"
            >SELESAI</a
          >
        </div>
      </div>
    </div>

    <div v-if="$store.state.otp.forgetPassword.emailSuccess" class="modal-confirm-email">
      <div class="modal-container">
        <div class="content">
          <p class="text-center copywriting">
            You will receive an email contained link for reset your password.
            <br />
            <strong>Check your e-mail.</strong>
          </p>
          <a
            href=""
            class="button-minimalis button_style-danger button-finish button-block"
            @click.prevent="closeSuccessForgotPassword()"
            >DONE</a
          >
        </div>
      </div>
    </div>

    <ModalChangeNumber
      v-if="isShowModalChangeNumber"
      :is-registered="isRegisteredOffline"
      @submitted="changeNumberVerification"
    />
  </div>
</template>
<script>
const Config = require('~/config/default.env').default;
import Auth from '@/shared/auth';
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
export default {
  components: {
    OtpInput: () => import('@bachdgvn/vue-otp-input'),
    ModalChangeNumber: () => import('@/components/global/modal/ModalChangeNumber'),
    LoginThirdParty: () => import('./third-party'),
    OverseasPhone: () => import('@/components/global/login/overseas-phone'),
    loaderspin: () => import('@/shared/UIComponents/LoaderSpin'),
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },
  data() {
    return {
      loginData: {
        username: '',
        password: '',
        repassword: '',
        remember: '',
      },
      forgot: {
        email: '',
        phone: '',
        phone_formatted: '',
      },
      offlineRegistration: {
        phone: '',
        phone_code: '',
        user_id: '',
      },
      revealPassword: 'password',
      showLoader: false,
      state: {
        displayModal: false,
      },
      isErrorExist: false,
      isLoginModal: false,
      registerData: {
        username: '',
        firstname: '',
        lastname: '',
        gender: 'Female',
        email: '',
        password: '',
        repassword: '',
        referral_code: '',
        salute_id: 1,
        phone_no: '',
        phone_code: '',
        privacyPolicy: '',
      },
      revealRePassword: 'password',
      isInputUsernameFocus: false,
      isShowLabelOngkir: false,
      listSuggestionUsername: '',
      isUsernameAvailable: false,
      isInputPhoneFocus: false,
      enableVerification: false,
      isEmailDomainSuggestionShow: false,
      emailDomainSuggestion: [],
      domains: ['@gmail.com', '@yahoo.com', '@ymail.com', '@icloud.com'],
      isEmailAvailable: true,
      isPhoneAvailable: true,
      userProfile: {},
      errPhoneNumber: '',
      recaptchaToken: '',
      emailCheck: {
        error: '',
        loading: false,
      },
      phoneCheck: {
        error: '',
        loading: false,
      },
      phoneCheckOffline: {
        error: '',
        loading: false,
      },
      isRegisteredOffline: false,
      modalOfflineRegist: false,
      showConfirmEmail: false,
    };
  },
  computed: {
    disabledSubmit() {
      return !(this.offlineRegistration.phone && this.offlineRegistration.phone.length >= 4);
    },
    ...mapGetters([
      'otpScope',
      'otpMethod',
      'otpError',
      'verification',
      'forgetPassword',
      'otpIntervalCount',
      'verificationAddress',
      'formattedPhoneNumber',
      'smsEnabled',
      'whatsappEnabled',
      'emailEnabled',
      'maxReached',
    ]),
    ...mapState({
      isOtpSent: (state) => state.otp.isOtpSent,
      otpCheckLoading: (state) => state.otp.enableCheck.loading,
      loginWithSocoQueries: (state) => state.loginWithSocoQueries,
    }),
    modalState() {
      return this.$store.state.modal.loginPage.data;
    },
    inForgotPasswordState() {
      return this.$store.state.otp.scope === 'forget-password';
    },
    inChangeNumberState() {
      return this.$store.state.otp.scope === 'change-number';
    },
    isRegisteredSociollaStore() {
      return this.$store.state.otp.scope === 'registered_sociolla_store';
    },
    socoWeb() {
      return this.$store.state.SOCO_WEB_URL;
    },
    screen() {
      return this.$store.state.screen;
    },
    isResetPasswordTokenExpired() {
      return this.$store.state.isResetPasswordTokenExpired;
    },
    routeName() {
      return this.$route.name;
    },
    verificationSubHead() {
      return !this.inForgotPasswordState
        ? 'To ensure your account security, we will send you a verification code.'
        : 'Before changing your password, please verify your account first.';
    },
    formattedEmail() {
      const email = this.registerData.email;
      const atPresent = email.indexOf('@');
      if (atPresent > -1) {
        return email.substr(0, atPresent);
      }
      return email;
    },
    formattedForgotEmail() {
      const emailforgot = this.forgot.email;
      const atPresent = emailforgot.indexOf('@');
      if (atPresent > -1) {
        return emailforgot.substr(0, atPresent);
      }
      return emailforgot;
    },
    sendOtpEndpoint() {
      if (this.inForgotPasswordState) {
        return 'forget-password';
      }
      return 'otp/code';
    },
    validateOtpEndpoint() {
      if (this.inForgotPasswordState) {
        return 'forget-password';
      }
      return 'otp/verify';
    },
    isShowModalChangeNumber() {
      return this.$store.state.modal.isModalShow.changeNumber;
    },
    isShowModalOverseas() {
      return this.$store.state.modal.isModalShow.overseasPhone;
    },
    isShowModalPrivacyPolicy() {
      return this.$store.state.modal.isModalShow.privacyPolicy;
    },
    isShowModalTermsofservice() {
      return this.$store.state.modal.isModalShow.termsofservice;
    },
    isShowModalForgetPassword() {
      return this.$store.state.modal.isModalShow.forgetPassword;
    },
    isShowModalOtpCode() {
      return this.$store.state.modal.isModalShow.otpCode;
    },
    showMessageLimit() {
      return this.$store.state.showMessageLimit;
    },
    showMessageLimitCount() {
      return this.$store.state.showMessageLimitCount;
    },
    showMessageUserDeleted() {
      return this.$store.state.showMessageUserDeleted;
    },
    isShowModalOfflineRegist() {
      return this.$store.state.modal.isModalShow.offlineRegistration;
    },
    showForgotPasswordModal() {
      return this.modalState == 3 || this.$store.state.modal.isModalShow.forgetPassword;
    },
    isRegisterButtonAvailable() {
      return Boolean(
        this.isAllFieldFilled &&
          !this.$SO.size(this.listSuggestionUsername) &&
          this.isEmailAvailable &&
          this.isPhoneAvailable &&
          this.recaptchaToken &&
          !this.emailCheck.loading &&
          this.registerData.privacyPolicy
      );
    },
    // eslint-disable-next-line vue/no-async-in-computed-properties
    async isAllFieldFilled() {
      const deepRegisterData = JSON.parse(JSON.stringify(this.registerData));
      delete deepRegisterData['referral_code'];
      delete deepRegisterData['repassword'];
      return (
        Object.keys(deepRegisterData).every((key) => deepRegisterData[key]) &&
        // eslint-disable-next-line vue/no-async-in-computed-properties
        (await this.$validator.validateAll('form-register'))
      );
    },
    userCountry() {
      return this.$store.state.otp.userCountry;
    },
  },
  watch: {
    modalState(newVal) {
      if (newVal === 0) {
        document.body.classList.remove('no-scroll');
      } else {
        document.body.classList.add('no-scroll');
      }
    },
    isShowModalChangeNumber(newVal) {
      if (!newVal) {
        this.setModalState(4);
      }
    },
  },
  mounted() {
    this.getCountry();
    this.otpServiceEnableCheck();
    this.isRegisteredOffline = false;
  },
  beforeDestroy() {
    this.$SO('#app').removeClass('noscroll');
    document.documentElement.classList.remove('noscroll');
  },
  methods: {
    ...mapActions([
      'sendOtpAgain',
      'changeNumberVerification',
      'checkPhoneNumberAvailability',
      'selectOtpMethod',
      'submitOtp',
      'submitForget',
      'sendOtp',
      'submitOfflineRegist',
      'otpServiceEnableCheck',
    ]),
    ...mapMutations([
      'setOtpMethod',
      'setOtpScope',
      'setVerification',
      'setOtpCode',
      'setForgetPassword',
      'setIsOtpSent',
      'setOfflineRegist',
    ]),
    onFocusInInputUsername() {
      this.isInputUsernameFocus = true;
    },
    onFocusInInputLogin() {
      this.isShowLabelOngkir = true;
    },
    onBlurInInputLogin() {
      this.isShowLabelOngkir = false;
    },
    async validateBeforeSubmit(scope) {
      const validate = await this.$validator.validateAll(scope);
      if (validate) {
        if (scope == 'form-login') {
          this.showLoader = true;
          Auth.login(this).then(() => {});
        }
        if (scope == 'form-register' && this.isRegisterButtonAvailable) {
          this.showLoader = true;
          if (
            this.$store.state.otp &&
            this.$store.state.otp.userCountry &&
            this.$store.state.otp.userCountry.phone_code
          ) {
            this.registerData.phone_code = this.$store.state.otp.userCountry.phone_code;
          } else {
            this.registerData.phone_code = '+62';
          }
          const register = await Auth.register(this);
          if (register && register.success) {
            const profile = await axios.get(Config.MS_ACCOUNTS_API_URL + '/user/me');
            if ('data' in profile && 'data' in profile.data && profile.data.success) {
              this.registerData['is_verified_phone'] = profile.data.data.is_verified_phone;
              this.$store.commit('loggedIn', true);
              this.$store.commit('registerState', this.registerData);
              this.otpServiceEnableCheck();
              this.setupVerificationData(this.registerData);
              if (
                Object.keys(this.$store.state.otp.userCountry).length &&
                this.$store.state.otp.userCountry.phone_code !== '+62' &&
                this.$store.state.otp.userCountry.phone_code !== '+84'
              ) {
                // this.$router.push('/verification');
                // this.selectOtpMethod('whatsapp');
                this.setOtpMethod('whatsapp');
                this.setIsOtpSent(true);
                this.sendOtp();
              }
            } else {
              this.$toasted.global('Silakan coba beberapa saat lagi.');
            }
          }
        }
      }
    },
    validateBeforeSubmitReg(scope) {
      this.$validator.validateAll(scope).then((result) => {
        this.showLoader = true;
        Auth.checkusername(this).then(() => {});
        return;
      });
    },
    togglePassword() {
      if (this.revealPassword === 'password') {
        this.revealPassword = 'text';
      } else {
        this.revealPassword = 'password';
      }
    },
    toggleRePassword() {
      if (this.revealRePassword === 'password') {
        this.revealRePassword = 'text';
      } else {
        this.revealRePassword = 'password';
      }
    },
    clearErrorForm() {
      this.$store.commit('clearErrorFormLogin');
    },
    changeNavbarState(numb) {
      axios
        .get(Config.MS_ACCOUNTS_API_URL + '/user/me')
        .then((response) => {
          if (response.data.success) {
            this.$store.commit('profileState', response.data.data);
            this.$store.commit('userProfile', response.data.data);
            this.$store.commit('loggedIn', true);
          }
        })
        .catch((error) => {
          // console.log(Config.MS_SOCO_PUBLIC_API_URL + '/user/me')
          // console.log(error)
        });
      this.$store.commit('setMessageLimit', false);
      this.$store.commit('setMessageLimitCount', '');
      this.$store.commit('setMessageUserDeleted', false);
      if (this.state.navbar !== numb) {
        if (numb == 0) {
          this.$nextTick(() => {
            this.$validator.reset();
          });
          this.setModalState(0);
        }
        if (numb == 1) {
          this.setModalState(1);
          this.toggleModalFalse();
          this.$nextTick(() => {
            this.$validator.reset();
          });
        }
        if (numb == 2) {
          this.setModalState(2);
          this.toggleModalFalse();
          this.$nextTick(() => {
            this.$validator.reset();
          });
        }
        if (numb == 3) {
          this.setModalState(3);
          Object.keys(this.forgot).forEach((key) => {
            this.forgot[key] = '';
          });
          this.setOtpMethod('');
          this.$nextTick(() => {
            this.$validator.reset();
          });
        }
        if (numb == 4) {
          this.setModalState(4);
        }
        if (numb == 5) {
          this.isRegisteredOffline = true;
          if (this.screen.isDesktop) {
            this.setModalState(5);
          } else {
            this.$store.commit('toggleModalGlobalState', {
              modalName: 'offlineRegistration',
            });
          }
        }
      }
      const parent = document.querySelector('#app');
      parent.classList.add('noscroll');
    },
    pickUsenameSuggestion(key) {
      this.registerData.username = this.listSuggestionUsername[key];
      this.listSuggestionUsername = '';
    },
    verifyUsername() {
      this.isInputUsernameFocus = false;
      if (this.registerData.username.length >= 2) {
        axios
          .post(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/username/suggestions`, {
            user_name: this.registerData.username,
          })
          .then((response) => {
            if (response.status === 200) {
              if (this.$SO.size(response.data.data)) {
                this.listSuggestionUsername = response.data.data;
                this.isUsernameAvailable = false;
              } else {
                this.listSuggestionUsername = '';
                this.isUsernameAvailable = true;
              }
            } else {
              this.listSuggestionUsername = '';
              this.isUsernameAvailable = false;
            }
          })
          .catch((err) => {
            this.listSuggestionUsername = '';
            this.isUsernameAvailable = false;
          });
      }
    },
    verifyEmail(email) {
      if (!this.registerData.email || this.errors.has('form-register.email')) {
        return;
      }
      this.emailCheck.loading = true;
      this.emailCheck.error = '';
      this.isEmailAvailable = true;
      return axios
        .post(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/email/check`, {
          email: email,
        })
        .then((response) => {
          if (response.status === 200 && response.data) {
            this.isEmailAvailable = this.registerData.email ? !response.data.data : true;
            if (response.data.data) {
              this.emailCheck.error = 'Email sudah terdaftar di SOCO';
            }
            if (this.isEmailAvailable && this.otpScope === 'forget-password') {
              this.$toasted.global.error('Email tidak terdaftar');
              return false;
            }
          }
          return true;
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.emailCheck.error = error.response.data.message;
            this.isEmailAvailable = false;
          }
        })
        .finally(() => {
          this.emailCheck.loading = false;
        });
    },
    onBlurInInputPhone(phone_no) {
      this.phoneCheck.loading = true;
      this.phoneCheck.error = '';
      this.isInputPhoneFocus = false;
      const phone_code =
        (this.$store.state.otp && this.$store.state.otp.userCountry && this.$store.state.otp.userCountry.phone_code) ||
        '+62';
      this.checkPhoneNumberAvailability({ phone_no, phone_code })
        .then((response) => {
          const res = response.data;
          if (typeof response == 'boolean' && response) {
            this.isPhoneAvailable = response;
          } else {
            let errMessage = res.errorCode;
            if (response.errorCode === 'ALREADY_TAKEN') {
              errMessage = 'Phone number already registered in SOCO.';
            } else if (response.errorCode === 'INVALID_PHONE_NUMBER') {
              errMessage = 'Your phone number was invalid. Please check again';
            } else if (res.is_registered_offline && !res.is_profile_created) {
              errMessage = 'Your phone number already registered in Sociolla Store.';
              this.isRegisteredOffline = true;
            }
            this.phoneCheck.error = errMessage;
            this.isPhoneAvailable = false;
          }
        })
        .finally(() => (this.phoneCheck.loading = false));
    },
    onBlurInInputPhoneOffline(phone_no) {
      this.phoneCheckOffline.loading = true;
      this.phoneCheckOffline.error = '';
      this.isInputPhoneFocus = false;
      const phone_code =
        (this.$store.state.otp && this.$store.state.otp.userCountry && this.$store.state.otp.userCountry.phone_code) ||
        '+62';
      this.checkPhoneNumberAvailability({ phone_no, phone_code })
        .then((response) => {
          const res = response.data;
          if (typeof response == 'boolean' && response) {
            this.isPhoneAvailable = response;
          } else {
            let errMessage = res.errorCode;
            if (response.errorCode === 'ALREADY_TAKEN') {
              errMessage = 'Phone number already registered in SOCO.';
            } else if (response.errorCode === 'INVALID_PHONE_NUMBER') {
              errMessage = 'Your phone number was invalid. Please check again';
            } else if (res.is_registered_offline && !res.is_verified_phone) {
              this.isRegisteredOffline = true;
              this.offlineRegistration.user_id = res.user_id;
              this.setOfflineRegist({
                phone: phone_no,
                phone_code: phone_code,
                user_id: res.user_id,
              });
            }
            this.phoneCheckOffline.error = errMessage;
            this.isPhoneAvailable = false;
          }
        })
        .finally(() => (this.phoneCheckOffline.loading = false));
    },
    onFocusInInputPhone() {
      this.isInputPhoneFocus = true;
      this.isPhoneAvailable = true;
      this.phoneCheck.error = '';
    },
    onFocusInInputPhoneOffline() {
      this.isInputPhoneFocus = true;
      this.isPhoneAvailable = true;
      this.phoneCheckOffline.error = '';
    },
    otpChange(value) {
      const numInputs = this.$refs.otpInput.numInputs;
      const activeInputs = this.$refs.otpInput.otp.filter((e) => e !== '');
      if (activeInputs.length === numInputs) {
        this.enableVerification = true;
      } else {
        this.enableVerification = false;
      }
    },
    handleOnComplete(value) {
      const numInputs = this.$refs.otpInput.numInputs;
      if (value.length === numInputs) {
        this.enableVerification = true;
        this.setOtpCode(value);
      } else {
        this.enableVerification = false;
      }
    },
    resetPhoneNumber() {
      this.$store.commit('resetPhoneNumber');
    },
    setforgetPasswordBy(value) {
      this.setForgetPassword({ mode: value });
    },
    showEmailDomainSuggestion({ key }) {
      const regex = new RegExp(/@([a-zA-Z0-9_\-\.]+)?/, 'gi');
      const matchedInput = this.registerData.email.match(regex);
      const domains = this.domains;
      if (Boolean(matchedInput)) {
        this.emailDomainSuggestion = domains.filter((domain) => {
          return domain.match(matchedInput[0]);
        });
        if (!this.emailDomainSuggestion.length) {
          this.hideShowEmailDomainSuggestion();
          return;
        }
      } else {
        this.emailDomainSuggestion = domains;
      }
      this.isEmailDomainSuggestionShow = key === '@' || this.registerData.email.indexOf('@') > -1;
    },
    hideShowEmailDomainSuggestion() {
      this.isEmailDomainSuggestionShow = false;
    },
    populateEmailSuggestion(idx) {
      this.registerData.email = this.formattedEmail + this.emailDomainSuggestion[idx];
      this.isEmailDomainSuggestionShow = false;
    },
    showForgotEmailDomainSuggestion({ key }) {
      const regex = new RegExp(/@([a-zA-Z0-9_\-\.]+)?/, 'gi');
      const matchedInput = this.forgot.email.match(regex);
      const domains = this.domains;
      if (Boolean(matchedInput)) {
        this.emailDomainSuggestion = domains.filter((domain) => {
          return domain.match(matchedInput[0]);
        });
        if (!this.emailDomainSuggestion.length) {
          this.hideShowForgotEmailDomainSuggestion();
          return;
        }
      } else {
        this.emailDomainSuggestion = domains;
      }
      this.isEmailDomainSuggestionShow = key === '@' || this.forgot.email.indexOf('@') > -1;
    },
    hideShowForgotEmailDomainSuggestion() {
      this.isEmailDomainSuggestionShow = false;
    },
    populateForgotEmailSuggestion(idx) {
      this.forgot.email = this.formattedForgotEmail + this.emailDomainSuggestion[idx];
      this.isEmailDomainSuggestionShow = false;
    },
    generateUserName() {
      const firstName = this.registerData.firstname;
      const lastName = this.registerData.lastname;
      if (firstName && lastName) {
        const userName = firstName + lastName;
        this.registerData.username = userName.substr(0, 16).toLowerCase();
        this.verifyUsername();
      }
    },
    toggleChangeNumberModal() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'changeNumber',
      });
    },
    setupVerificationData(registerData) {
      this.setOtpScope('verification');
      this.setVerification({
        phone: registerData.phone_no,
        email: registerData.email,
      });
    },
    setModalState(state) {
      this.$store.commit('setDataModal', {
        modalName: 'loginPage',
        value: state,
      });
    },
    submitForgetPassword(forgetData) {
      const validateForm = this.$validator.validateAll('form-forgot');
      if (this.$store.state.otp && this.$store.state.otp.userCountry && this.$store.state.otp.userCountry.phone_code) {
        forgetData.phone_code = this.$store.state.otp.userCountry.phone_code;
      } else {
        forgetData.phone_code = '+62';
      }
      if (validateForm) {
        this.showLoader = true;
        this.otpServiceEnableCheck();
        this.setIsOtpSent(false);
        this.setForgetPassword({
          email: forgetData.email,
          phone: forgetData.phone,
          phone_code: forgetData.phone_code,
        });
        this.submitForget();
        this.showLoader = false;
      }
    },
    submitOfflineRegistration(offlineData) {
      const validateForm = this.$validator.validateAll('form-offline');
      if (this.$store.state.otp && this.$store.state.otp.userCountry && this.$store.state.otp.userCountry.phone_code) {
        offlineData.phone_code = this.$store.state.otp.userCountry.phone_code;
      } else {
        offlineData.phone_code = '+62';
      }
      if (this.phoneCheckOffline.error) {
        if (this.phoneCheckOffline.error == 'Phone number already registered in SOCO.') {
          this.$toasted.global.show('Your profile is already completed. You can login now!');
        } else {
          this.$toasted.global.show(`${this.phoneCheckOffline.error}`);
        }
        this.$store.commit('toggleModalGlobalState', {
          modalName: 'offlineRegistration',
        });
        this.offlineRegistration.phone = '';
        this.offlineRegistration.user_id = '';
        this.phoneCheckOffline.error = '';
        this.changeNavbarState(1);
      } else if (!this.phoneCheckOffline.error && validateForm) {
        this.showLoader = true;
        this.otpServiceEnableCheck();
        this.setIsOtpSent(false);
        this.setOfflineRegist({
          phone: offlineData.phone,
          phone_code: offlineData.phone_code,
          user_id: this.offlineRegistration.user_id,
        });
        this.submitOfflineRegist();
        this.$store.commit('toggleModalGlobalState', {
          modalName: 'offlineRegistration',
        });
        this.showLoader = false;
      }
    },
    submitOtpFromInstance() {
      this.submitOtp(this);
    },
    submitOtpCallback() {
      if (this.isRegisteredSociollaStore) {
        window.location.href = `${this.socoWeb}/quick-registration/complete-account?scope=registered_sociolla_store`;
      }
    },
    toggleModalFalse() {
      if (this.isShowModalForgetPassword) {
        this.$store.commit('toggleModalGlobalState', { modalName: 'forgetPassword' }, { root: true });
      }
      if (this.isShowModalOtpCode) {
        this.$store.commit('toggleModalGlobalState', { modalName: 'otpCode' }, { root: true });
      }
      if (this.isShowModalOverseas) {
        this.$store.commit('toggleModalGlobalState', { modalName: 'overseasPhone' }, { root: true });
      }
    },
    resendCompleteProfile() {
      // [PUT] {{MS_SOCO_PUBLIC_API_URL}}/auth/quick-register/resend
      const { forgetPassword, showForgotPasswordModal, loginData } = this;
      axios
        .put(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/quick-register/resend`, {
          entity: showForgotPasswordModal ? forgetPassword[forgetPassword['mode']] : loginData['username'],
        })
        .then((response) => {
          if (response.status === 200) {
            this.changeNavbarState(0);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit('setIsQuickRegisterLoginError', false);
        });
    },
    onRecaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.recaptchaToken = '';
    },
    onRecaptchaError(error) {
      this.$toasted.global.error('Please try again later');
      console.log(error);
    },
    onRecaptchaVerify(token) {
      this.recaptchaToken = token;
    },
    skipVerification() {
      this.setModalState(0);
    },
    showOverseas() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'overseasPhone',
      });
    },
    showPrivacyPolicyModal() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'privacyPolicy' }, { root: true });
    },
    showTermsofserviceModal() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'tnc' }, { root: true });
    },
    toggleModalAuth(form) {
      this.setModalState(form);
      this.$store.commit('setMessageLimit', false, { module: 'auth' });
      this.$store.commit('setMessageLimitCount', '', { module: 'auth' });
      this.$store.commit('setMessageUserDeleted', false, { module: 'auth' });
      if (form == 0) {
        this.$store.commit('setMessageLimit', false, { module: 'auth' });
        this.$store.commit('setMessageLimitCount', '', { module: 'auth' });
        this.$store.commit('setMessageUserDeleted', false, { module: 'auth' });
        this.$store.dispatch('lockBg', false, { module: 'auth' });
      }
    },
    getCountry() {
      this.$store.dispatch('fetchCountry');
    },
    closeSuccessForgotPassword() {
      this.$store.commit('setEmailSuccess', false);
      this.changeNavbarState(0);
    },
  },
};
</script>

<style lang="scss">
@import 'login-v2';
</style>
